import { h } from "preact";
import { useState, useEffect, } from "preact/hooks";
import { Box, Button, Grid, Paper, Stepper, Step, StepLabel, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";

import Deal1 from "../Deal/Deal1";
import AmbassadorAppliance from "../Common/AmbassadorAppliance";
import BienDescriptif from "../RealEstate/BienDescriptif";

import BiensDuDeal from "../RealEstate/BiensDuDeal";
import DealPrice from "../RealEstate/DealPrice";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	margin: {
		margin: theme.spacing(1),
	},
	withoutLabel: {
		marginTop: theme.spacing(3),
	},
	textField: {},
	textField2: { minWidth: "400px" },
	option: {
		fontSize: 15,
		"& > span": {
			marginRight: 10,
			fontSize: 18,
		},
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: "#fff",
	},
}));

export default function DealNewV({ id, step }) {
	console.log("DealNewV");
	const classes = useStyles();
	const steps = [
		<span
		// onClick={() => {
		// 	window.location.replace("/newdealv/" + id + "/0");
		// }}
		>
			L'ambassadeur
		</span>,
		<span
		// onClick={() => {
		// 	window.location.replace("/newdealv/" + id + "/1");
		// }}
		>
			Les biens
		</span>,
		<span
		// onClick={() => {
		// 	window.location.replace("/newdealv/" + id + "/2");
		// }}
		>
			Prix
		</span>,
		<span
		// onClick={() => {
		// 	window.location.replace("/newdealv/" + id + "/3");
		// }}
		>
			Vendeurs
		</span>,

		<span
		// onClick={() => {
		// 	window.location.replace("/newdealv/" + id + "/4");
		// }}
		>
			Récapitulatif
		</span>,
	];

	const [state, setState] = useState({ loaded: false, mode: "VN", tunnel: true }); //parseInt(step) });

	const handleChange = (prop) => (event) => {
		setState({ ...values, [prop]: event.target.value });
	};

	const getAgregateState = (st) => {
		switch (st) {
			case "0":
				return 0;
				break;
			case "00":
				return 1;
				break;
			case "2":
				return 2;
				break;
			case "1":
				return 1;
				break;
			case "1_2":
				return 1;
				break;
			case "1_3":
				return 1;
				break;
			case "3":
				return 3;
				break;
			case "4":
				return 4;
				break;
		}
	};

	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/eeef1f95231e4b76a28dd8ee227f07c6/" + id + "/" + step, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						console.log("set state", res.pld);
						setState((state) => ({
							...state,
							...res.pld,
							loaded: true,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	if (state.loaded === false) return false;
	console.log("state", state);
	return (
		<div style="">
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Paper style="padding: 10px;">
						{" "}
						<Stepper activeStep={getAgregateState(step)} alternativeLabel>
							{steps.map((label) => (
								<Step key={label}>
									<StepLabel>{label}</StepLabel>
								</Step>
							))}
						</Stepper>
					</Paper>
				</Grid>
				<Grid item xs={3}>
					{step === "0" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">

							<Typography variant="h5">Si vous le souhaitez, Bkeys vous offre la possibilité de désigner un ambassadeur.</Typography>
							<Typography variant="body1" style="margin-bottom: 10px;">
								Cet ambassadeur sera en charge des visites de votre bien et vous assistera dans les démarches.
							</Typography>
							<Typography variant="body1" style="margin-bottom: 10px;">
								Pour se faire, vous devez renseigner ses nom et prénom ainsi que son email.

								Nous l'inviterons ensuite à s'inscrire s'il ne fait encore partie de la communauté Bkeys.
							</Typography>
						</Paper>
					)}
					{step === "00" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							<Typography variant="h6">
								Merci d'indiquer l'adresse du bien que vous souhaitez aider à vendre.
							</Typography>
						</Paper>
					)}
					{step === "1" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							<Typography variant="h5">
								Ici vous pouvez décrire la liste de vos biens composant la transaction que vous souhaitez effectuer
							</Typography>
							<Typography variant="body1">&nbsp;</Typography>
							<Typography variant="body1">Vous devrez:</Typography>
							<Typography variant="body1">- Indiquer une adresse</Typography>
							<Typography variant="body1">- Renseigner les caractéristiques du bien selon sa nature</Typography>
							<Typography variant="body1">- Uploader des photos mettant le bien en valeur</Typography>
						</Paper>
					)}
					{step === "1_2" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							<Typography variant="h5">
								Ici vous pouvez décrire la liste de vos biens composant la transaction que vous souhaitez effectuer
							</Typography>
							<Typography variant="body1">&nbsp;</Typography>
							<Typography variant="body1">Vous devrez:</Typography>
							<Typography variant="body1">- Indiquer une adresse</Typography>
							<Typography variant="body1">- Renseigner les caractéristiques du bien selon sa nature</Typography>
							<Typography variant="body1">- Uploader des photos mettant le bien en valeur</Typography>
						</Paper>
					)}
					{step === "1_3" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							<Typography variant="h5">
								Ici vous pouvez décrire la liste de vos biens composant la transaction que vous souhaitez effectuer
							</Typography>
							<Typography variant="body1">&nbsp;</Typography>
							<Typography variant="body1">Vous devrez:</Typography>
							<Typography variant="body1">- Indiquer une adresse</Typography>
							<Typography variant="body1">- Renseigner les caractéristiques du bien selon sa nature</Typography>
							<Typography variant="body1">- Uploader des photos mettant le bien en valeur</Typography>
						</Paper>
					)}
					{step === "2" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							<Typography variant="h5" style="margin-bottom: 10px;">
								Ici vous devez fixer le prix de vente de votre bien.
							</Typography>

							<Typography variant="body1">La détermination du prix est la partie délicate de la mise en vente.
								Surestimer votre bien impactera la transaction: votre bien risque de ne pas se vendre dans le délai que vous souhaitez.
							</Typography>
						</Paper>
					)}
					{step === "3" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">

							<Typography variant="body1" style="margin-bottom: 10px;">
								Ici vous devez ajouter renseigner toutes les autres personnes qui possèdent ce bien avec vous.
							</Typography>
							<Typography variant="body1">
								Si vous êtes le seul et unique propriétaire de ce bien, vous pouvez cliquer sur continuer.
							</Typography>
						</Paper>
					)}
					{step === "4" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">

						</Paper>
					)}
				</Grid>
				<Grid item xs={9}>
					<Paper style="padding: 10px; ">
						{step == "0" && <AmbassadorAppliance values={state} setValues={setState} />}
						{step === "00" && <BiensDuDeal setUpperState={setState} upperState={state} />}
						{step === "2" && <DealPrice setUpperState={setState} upperState={state} mode="V" />}
						{(step === "1" || step === "1_2" || step === "1_3") && <BienDescriptif setUpperState={setState} upperState={state} tab={step} />}
						{/* {step === "1_2" && <BienDescriptif setUpperState={setState} upperState={state} tab={1} />}
						{step === "1_3" && <BienDescriptif setUpperState={setState} upperState={state} tab={2} />} */}
						{step === "3" && <Deal1 upperState={state} />}

						{step === "4" && (
							<div>
								<Typography variant="h5" style="margin-bottom: 10px;">
									Félicitations !
								</Typography>
								<Typography variant="body1" style="margin-bottom: 10px;">
									En résumé, vous voulez vendre :
								</Typography>
								{state.assets.map((asset) => {
									return (
										<Typography variant="body1" style="margin-bottom: 10px;">
											Un {asset.type_name} {asset.srf !== null ? ` de ${asset.srf} m2` : null} situé au {asset.a}
										</Typography>
									);
								})}
								<Typography variant="body1" style="margin-bottom: 10px;">
									Au prix net vendeur de {state.price} €
								</Typography>
								<Typography variant="body1">
									La prochaine étape est de signer le mandat de vente avec vos éventuels co-vendeurs.
								</Typography>
								<Typography style="margin-top: 10px;" variant="body1">
									Cette action permettra la mise en vente effective de votre bien sur le site.
								</Typography>

								{/* <Button
									variant="contained"
									onClick={() => {
										window.location.href = "/11d1355181ac4376a09980601b420617/" + state.uid;
									}}
								>
									Voir le dossier de vente
								</Button> */}
								<Box display="flex" justifyContent="flex-end" alignItems="center" style="margin-top: 10px;">
									<Box>
										<Button
											variant="contained"
											onClick={() => {
												window.location.href = "/dashboardv";
											}}
										>
											Aller à mon espace
										</Button>{" "}
									</Box>
								</Box>
							</div>
						)}
					</Paper>
				</Grid>

			</Grid>
		</div>
	);
}
